
class ParceiroAgregado {
    id: Number = 0;
    "codigoFornecedorSAP": Number = 0;
    "cliforSAPAgregado": Number = 0;
    "criadoEm": Date = new Date();
    "excluidoEm": Date = new Date();
    "d_E_L_E_T_E": boolean = false;  
  }
  export default ParceiroAgregado;
  